
console.log('Hello World')


document.addEventListener('DOMContentLoaded', function () {
	// Select all elements with the class 'section'
	const sections = document.querySelectorAll('.flexible-row');

	let bgColor = ''; // Variable to store the background color

	if (sections.length > 0) {
		// Get the last section's background color
		const lastSection = sections[sections.length - 1];
		bgColor = window.getComputedStyle(lastSection).backgroundColor;
	} else {
		// If no sections exist, get the background color from #main
		const mainElement = document.getElementById('main');
		if (mainElement) {
			bgColor = window.getComputedStyle(mainElement).backgroundColor;
		}
	}

	// Apply the background color to the #main-footer-rocket if found
	const footerRocket = document.getElementById('main-footer-rocket');
	if (footerRocket && bgColor) {
		footerRocket.style.backgroundColor = bgColor;
	}
});

